"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _commonReact = require("@devsta/common-react");

var _clientAwsS = require("@devsta/client-aws-s3");

var _OrganisationManager = _interopRequireDefault(require("./OrganisationManager"));

var _EditingTeam = _interopRequireDefault(require("./EditingTeam"));

var _SubscriptionPackage = _interopRequireDefault(require("./SubscriptionPackage"));

var _EditOrganisationStage = _interopRequireDefault(require("../../EditOrganisationStage"));

var _validateOrganisation = _interopRequireDefault(require("../../../utils/validation/validateOrganisation"));

var _buildSubscriptionPayload = _interopRequireDefault(require("../utils/buildSubscriptionPayload"));

var _SubscriptionDetailsLoading = _interopRequireDefault(require("./SubscriptionDetailsLoading"));

require("../styles/_subscription-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var REQUIRED_SUB_FIELDS = ['editingTeam', 'subPackage', 'billingEntityCode'];

function findUser(id, users) {
  return users.find(function (user) {
    return user.userId === id;
  });
}

function resolveTeamImageUrls(_x, _x2, _x3) {
  return _resolveTeamImageUrls.apply(this, arguments);
}

function _resolveTeamImageUrls() {
  _resolveTeamImageUrls = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(teams, apolloClient, shootstaOrgId) {
    var _ref8, _ref9, teamsWithImage;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all([(0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
              apiClient: apolloClient,
              dataArray: teams.map(function (team) {
                return _objectSpread({}, team, {
                  organisationId: shootstaOrgId
                });
              }),
              substitutedKeys: ['imageUrl']
            })]);

          case 2:
            _ref8 = _context4.sent;
            _ref9 = _slicedToArray(_ref8, 1);
            teamsWithImage = _ref9[0];
            return _context4.abrupt("return", Promise.all(teamsWithImage.map( /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(team) {
                var membersPreview;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                          apiClient: apolloClient,
                          dataArray: team.membersPreview.map(function (preview) {
                            return _objectSpread({}, preview, {
                              organisationId: shootstaOrgId
                            });
                          }),
                          substitutedKeys: ['imageUrl']
                        });

                      case 2:
                        membersPreview = _context3.sent;
                        return _context3.abrupt("return", _objectSpread({}, team, {
                          membersPreview: membersPreview
                        }));

                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x4) {
                return _ref10.apply(this, arguments);
              };
            }())));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _resolveTeamImageUrls.apply(this, arguments);
}

var SubscriptionDetails = /*#__PURE__*/function (_Component) {
  _inherits(SubscriptionDetails, _Component);

  function SubscriptionDetails(props) {
    var _this;

    _classCallCheck(this, SubscriptionDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubscriptionDetails).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateSubscriptionField", (0, _lodash.default)(function (fieldName) {
      return function (result) {
        _this.setState(_defineProperty({}, fieldName, result));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchTeamsAndUsers", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getUsersAndTeams, _this$props$organisat, editingTeamId, accountManagerId, bdmId, apolloClient, shootstaOrgId, _ref2, data, error, getTeams, accountManagers, bdms, _ref3, _ref4, teamsWithImages, amsWithImages, bdmsWithImages;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getUsersAndTeams = _this$props.getUsersAndTeams, _this$props$organisat = _this$props.organisation, editingTeamId = _this$props$organisat.editingTeamId, accountManagerId = _this$props$organisat.accountManagerId, bdmId = _this$props$organisat.bdmId, apolloClient = _this$props.apolloClient, shootstaOrgId = _this$props.shootstaOrgId;
              _context.next = 3;
              return getUsersAndTeams();

            case 3:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (!(error || !data)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: error
              }));

            case 8:
              getTeams = data.getTeams, accountManagers = data.accountManagers, bdms = data.bdms;
              _context.prev = 9;
              _context.next = 12;
              return Promise.all([resolveTeamImageUrls(getTeams, apolloClient, shootstaOrgId), (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apolloClient,
                dataArray: accountManagers.map(function (manager) {
                  return _objectSpread({}, manager, {
                    organisationId: shootstaOrgId
                  });
                }),
                substitutedKeys: ['imageUrl']
              }), (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: apolloClient,
                dataArray: bdms.map(function (bdm) {
                  return _objectSpread({}, bdm, {
                    organisationId: shootstaOrgId
                  });
                }),
                substitutedKeys: ['imageUrl']
              })]);

            case 12:
              _ref3 = _context.sent;
              _ref4 = _slicedToArray(_ref3, 3);
              teamsWithImages = _ref4[0];
              amsWithImages = _ref4[1];
              bdmsWithImages = _ref4[2];

              _this.setState(function (_ref5) {
                var accountManager = _ref5.accountManager,
                    bdm = _ref5.bdm;
                return {
                  teams: teamsWithImages.filter(function (team) {
                    return team.type === 'EDITING';
                  }),
                  accountManagers: amsWithImages,
                  bdms: bdmsWithImages,
                  editingTeam: editingTeamId ? teamsWithImages.find(function (team) {
                    return team.teamId === editingTeamId;
                  }) : void 0,
                  accountManager: accountManagerId ? findUser(accountManagerId, amsWithImages) : accountManager,
                  bdm: bdmId ? findUser(bdmId, bdmsWithImages) : bdm
                };
              });

              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](9);
              return _context.abrupt("return", void _this.setState({
                error: _context.t0.message
              }));

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[9, 20]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSaveOrganisation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, updateOrganisation, organisation, goToNextWizardStage, hasUpdatePermission, input, _ref7, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, updateOrganisation = _this$props2.updateOrganisation, organisation = _this$props2.organisation, goToNextWizardStage = _this$props2.goToNextWizardStage, hasUpdatePermission = _this$props2.hasUpdatePermission;

              if (hasUpdatePermission) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", void goToNextWizardStage());

            case 3:
              _this.setState({
                saving: true
              });

              input = (0, _buildSubscriptionPayload.default)(organisation, _this.state);
              _context2.next = 7;
              return updateOrganisation({
                input: input
              });

            case 7:
              _ref7 = _context2.sent;
              error = _ref7.error;

              if (error) {
                _context2.next = 11;
                break;
              }

              return _context2.abrupt("return", void goToNextWizardStage());

            case 11:
              _this.setState({
                saving: false
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    var _organisation = props.organisation;
    _this.state = {
      saving: false,
      accountManager: _organisation.accountManager,
      billingEntityCode: _organisation.billingEntityCode,
      bdm: _organisation.bdm,
      subPackage: _organisation.package,
      equipment: _organisation.equipment
    };
    return _this;
  }

  _createClass(SubscriptionDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchTeamsAndUsers();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          saving = _this$state.saving,
          accountManager = _this$state.accountManager,
          billingEntityCode = _this$state.billingEntityCode,
          bdm = _this$state.bdm,
          editingTeam = _this$state.editingTeam,
          subPackage = _this$state.subPackage;
      var _this$props3 = this.props,
          organisations = _this$props3.organisations,
          hasUpdatePermission = _this$props3.hasUpdatePermission;
      var _this$state2 = this.state,
          bdms = _this$state2.bdms,
          accountManagers = _this$state2.accountManagers,
          teams = _this$state2.teams,
          error = _this$state2.error;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      if (!bdms || !accountManagers || !teams) {
        return _react.default.createElement(_EditOrganisationStage.default, {
          title: "Manage Client Subscription"
        }, _react.default.createElement("div", {
          className: "organisation-sub-details"
        }, _react.default.createElement(_SubscriptionDetailsLoading.default, null), _react.default.createElement(_uiKit.Button, {
          id: "submit-button",
          disabled: true
        }, hasUpdatePermission ? 'Save & Continue' : 'Continue')));
      }

      return _react.default.createElement(_EditOrganisationStage.default, {
        title: "Manage Client Subscription"
      }, _react.default.createElement("div", {
        className: "organisation-sub-details"
      }, _react.default.createElement(_SubscriptionPackage.default, {
        onSave: this.updateSubscriptionField('subPackage'),
        title: "Subscription Package*",
        assignedPackage: subPackage,
        disabled: !hasUpdatePermission,
        updateBillingEntityCode: this.updateSubscriptionField('billingEntityCode'),
        billingEntityCode: billingEntityCode
      }), _react.default.createElement(_OrganisationManager.default, {
        id: "acct-manager",
        onSave: this.updateSubscriptionField('accountManager'),
        users: accountManagers,
        title: "Account Manager",
        assignedManager: accountManager,
        disabled: !hasUpdatePermission
      }), _react.default.createElement(_OrganisationManager.default, {
        id: "business-development-manager",
        onSave: this.updateSubscriptionField('bdm'),
        users: bdms,
        title: "Business Development Manager",
        assignedManager: bdm,
        disabled: !hasUpdatePermission
      }), _react.default.createElement(_EditingTeam.default, {
        organisations: organisations,
        teams: teams,
        assignedEditingTeam: editingTeam,
        onSave: this.updateSubscriptionField('editingTeam'),
        title: "Editing Team*",
        disabled: !hasUpdatePermission
      }), _react.default.createElement(_uiKit.Button, {
        id: "submit-button",
        busy: saving,
        onClick: this.handleSaveOrganisation,
        disabled: !(0, _validateOrganisation.default)(this.state, REQUIRED_SUB_FIELDS)
      }, hasUpdatePermission ? 'Save & Continue' : 'Continue')));
    }
  }]);

  return SubscriptionDetails;
}(_react.Component);

exports.default = SubscriptionDetails;

_defineProperty(SubscriptionDetails, "defaultProps", {
  organisations: []
});